import { IFaireMoney } from "@faire/web-api/indigofair/data/IFaireMoney";
import { debounceIfPossible } from "@faire/web/common/globals/debounceIfPossible";

import { logWarning } from "./logging";

/**
 * Logs occurrences of FD-116725 in order to understand its impact
 *
 * @param money original argument of method formatMoney
 * @param workingMoney result of method getLocalCurrency, which could be the same IFaireMoney instance
 * as the argument money
 */
export const logMoneyMutation = debounceIfPossible(
  (money: IFaireMoney, workingMoney: IFaireMoney) => {
    const data = { money, workingMoney };
    logWarning("workingMoney.currency is undefined so setting it to 'USD'", {
      data,
    });
  },
  1000
);
